import { useId } from 'react';

type StarIconProps = {
    checked?: boolean;
    disabled?: boolean;
    size?: number | string;
    style?: React.CSSProperties;
};

function IconStar({
    checked = false,
    disabled = false,
    size = '1em',
    style = {},
}: StarIconProps) {
    const tipId = useId();

    const color = disabled ? '#212529' : '#272526';
    const backgroundColor = disabled ? '#f2f2f2' : 'white';

    return (
        <svg
            viewBox="-20 -20 140 140"
            aria-hidden="true"
            style={{
                display: 'block',
                width: size,
                height: size,
                // marginRight: '-0.25em',
                flexShrink: 0,
                overflow: 'visible',
                // marginTop: '.5em',
                // marginBottom: '.5em',
                // marginTop: '0.5em',
                // marginLeft: '0.5em',
                color,
                ...style,
            }}
        >
            <defs>
                <path
                    id={tipId}
                    d="
                        M 50 -50
                        L 43 14
                        L 57 14
                        Z
                    "
                />
            </defs>

            <use href={`#${tipId}`} fill="currentColor" />

            <use
                href={`#${tipId}`}
                fill="currentColor"
                transform="rotate(90 50 50)"
            />

            <use
                href={`#${tipId}`}
                fill="currentColor"
                transform="rotate(180 50 50)"
            />

            <use
                href={`#${tipId}`}
                fill="currentColor"
                transform="rotate(270 50 50)"
            />

            <path
                d="
                    M 50 100
                    C 50 87.717, 12.283 50, 0 50
                    C 12.283 50, 50 12.283, 50 0
                    C 50 12.283, 87.729 50, 100 50
                    C 87.729 50, 50 87.717, 50 100
                    Z
                "
                fill={backgroundColor}
                stroke="currentColor"
                strokeWidth="7"
                strokeLinejoin="miter"
                strokeMiterlimit="20"
                style={{
                    transition:
                        'fill 150ms ease, stroke 150ms ease',
                }}
            />

            {checked && (
                <path
                    d="
                        M 50 20
                        L 80 50
                        L 50 80
                        L 20 50
                        Z
                    "
                    fill="currentColor"
                    style={{
                        transformOrigin: '50px 50px',
                    }}
                />
            )}
        </svg>
    );
}

export default IconStar;